//请自行添加语言资源
const qcSecondary = {
  appointmentNo:'预约单号',
  sourceQcNo:'采样单号',
  creator:'二检填写人',
  startSecondaryUserNo: '二检发起人',
  createTime:'二检发起时间',
  secondaryQcReasonName:'二检原因',
  storageNameOld:'二检前库位',
  storgeBatchNoOld:'二检前批次',
  storageNameNew: '二检后库位',
  storgeBatchNoNew:'二检后批次',
  reqConfirmUserNo:'二检确认人',
  reqConfirmTime:'二检确认时间',
  reqStatusName: '二检确认结果',
  deductionWeight: '扣量',
  currentNodeName: '单据状态',
  supplierName: '货主名称',
  supplierDesc: '自卖户货主名称',
  vehicleNo: '车牌号',
  startSecondaryTime: '二检发起时间'
};
export default qcSecondary



// WEBPACK FOOTER //
// ./src/page/report/qcSecondary/lang/qcSecondary.en.js